import "./InputWrapper.scss"
import classnames from "classnames"
import isFunction from "lodash/isFunction"
import React, { Component } from "react"

class InputWrapper extends Component {
  constructor(props) {
    super(props)
    this.handleFocus = this.handleFocus.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.state = {
      focus: props.autoFocus,
    }
  }

  handleFocus() {
    this.props.onFocus && this.props.onFocus(this.props.value)
    if (!this.state.focus) {
      this.setState({ focus: true })
    }
  }

  handleBlur() {
    this.props.onBlur && this.props.onBlur(this.props.value)
    if (this.state.focus) {
      this.setState({ focus: false })
    }
  }

  render() {
    const { id, error, label, inline, status, success, children } = this.props
    const { focus } = this.state

    const className = classnames(
      "InputWrapper",
      {
        "InputWrapper-inline": inline,
        "InputWrapper-focus": focus,
        "InputWrapper-error": error,
        "InputWrapper-success": success,
      },
      this.props.className
    )

    const passProps = {
      focus: focus,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
    }

    return (
      <div className={className}>
        {label &&
          <label htmlFor={id} className="InputWrapper_label">
            {label}
          </label>}
        {isFunction(children) ? children(passProps) : children}
        <div className="InputWrapper_status">
          {error || status}
        </div>
      </div>
    )
  }
}

InputWrapper.displayName = "InputWrapper"

export default InputWrapper



// WEBPACK FOOTER //
// ./src/lib/form/InputWrapper.js